/**
 * If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.
 * tag: 40099
 * @readonly
 * @enum {number} (int)
 */
export enum ProvisionOptionSinglePartyBuyerSide {
  /** Buy */
  Buy = 1,
  /** Sell */
  Sell = 2,
}
